import React from "react";
import { SVGAsset } from "res";
import "./styles.css";

/**
 * @function UINotifiSearch
 * @param {STRING} placeHolder - Allows us to set the input placeholder.
 * @param {STRING} className - Allows us to pass a specific className to the search container.
 * @returns {React.Component}
 * @example
 * <UINotifiSearch className="some-class" placeHolder="Some text" />
 */

export default function UINotifiSearch(props) {
  const placeHolder = props.placeHolder ?? "";
  const className = props.className ?? "";
  const point = props.dataPoint ?? "";

  const ref = React.createRef();
  const onChange = evt => props.onChange instanceof Function
    ? props.onChange(ref.current.value)
    : undefined;

  return (
    <div className={`ui-notifi-search flex-width ${className}`}>
      <SVGAsset id="MagnifyingGlassIcon" className="search-icon" />
      <input ref={ ref } className="search-input" placeholder={placeHolder} onChange={ onChange } data-point={ point }></input>
    </div>
  );
}